<script setup lang="ts">
import PageContainer from "~/components/ui/PageContainer.vue";

const chapterCards = [
  {
    title: "Chapter 1: SDLC",
    description: "Software Development Life Cycle ke notes aur basic tayari.",
    actions: [
      { label: "Notes", to: "/11th/computer/sdlc/" },
      { label: "MCQs", to: "/11th/computer/sdlc/mcqs/" },
      { label: "Short Questions", to: "/11th/computer/sdlc/short-questions/" },
      { label: "Exercise", to: "/11th/computer/sdlc/exercise/" },
    ],
  },
  {
    title: "Chapter 2: Python",
    description: "Python chapter ke notes, MCQs aur short questions.",
    actions: [
      { label: "Notes", to: "/11th/computer/python/notes/" },
      { label: "MCQs", to: "/11th/computer/python/mcqs/" },
      { label: "Short Questions", to: "/11th/computer/python/short-questions/" },
      { label: "Solved Exercise", to: "/11th/computer/python/solved-exercise/" },
    ],
  },
  {
    title: "Chapter 3: Algorithms",
    description: "Algorithms, sorting aur searching ke notes.",
    actions: [
      { label: "Notes", to: "/11th/computer/algorithm/" },
      { label: "MCQs", to: "/11th/computer/algorithm/mcqs/" },
    ],
  },
  {
    title: "Chapter 4: Data Structures",
    description: "Lists, stacks, queues aur doosre important topics.",
    actions: [
      { label: "Notes", to: "/11th/computer/data-structures/" },
      { label: "MCQs", to: "/11th/computer/data-structures/mcqs/" },
    ],
  },
  {
    title: "Chapter 5: Data Analytics",
    description: "Data analytics ke concepts aur basic practice.",
    actions: [
      { label: "Notes", to: "/11th/computer/data-analytics/" },
      { label: "MCQs", to: "/11th/computer/data-analytics/mcqs/" },
    ],
  },
];

const quickAccessLinks = [
  { title: "Python MCQs", to: "/11th/computer/python/mcqs/" },
  { title: "Chapter 2 Notes", to: "/11th/computer/python/notes/" },
  { title: "Solved Exercises", to: "/11th/computer/solved-exercise/" },
  { title: "Short Questions", to: "/11th/computer/short-questions/" },
];

const learningPath = [
  { title: "Python", to: "/11th/computer/python/" },
  { title: "Algorithms", to: "/11th/computer/algorithm/" },
  { title: "Data Structures", to: "/11th/computer/data-structures/" },
];

usePageSeo({
  title: "11th Class Computer Notes (FSC Part 1) - Chapter Wise + MCQs + PDF",
  description: "11th class computer notes with chapter-wise explanation, MCQs, short questions and solved exercises. Easy Roman Urdu guide for FSC students.",
  keywords: "11th class computer notes, fsc part 1 computer notes, chapter wise computer notes, computer notes pdf",
  breadcrumbs: [
    { name: "Home", item: "/" },
    { name: "11th Computer", item: "/11th/computer/" },
    { name: "Notes", item: "/11th/computer/notes/" },
  ],
});
</script>

<template>
  <PageContainer>
    <EnglishHero
      headline="11th Class Computer"
      title="11th Class Computer Notes"
      description="Yahan se aap chapter-wise notes, MCQs, short questions aur solved exercises tak asani se ja sakte hain."
    />

    <EnglishSection
      title="Chapter-wise Notes"
      description="Apna chapter choose karein."
    >
      <div class="grid gap-4 lg:grid-cols-2">
        <div v-for="chapter in chapterCards" :key="chapter.title" class="rounded-[22px] border border-slate-200 bg-white p-4 dark:border-slate-700 dark:bg-slate-900">
          <h3 class="text-lg font-semibold text-slate-900 dark:text-white">{{ chapter.title }}</h3>
          <p class="mt-2 text-sm leading-6 text-slate-600 dark:text-slate-300">{{ chapter.description }}</p>
          <div class="mt-4 grid grid-cols-2 gap-3">
            <NuxtLink
              v-for="action in chapter.actions"
              :key="action.to + action.label"
              :to="action.to"
              class="rounded-2xl border border-slate-200 bg-slate-50 px-4 py-3 text-center text-sm font-medium text-slate-900 transition hover:border-amber-300 hover:bg-white dark:border-slate-700 dark:bg-slate-950/40 dark:text-white dark:hover:border-amber-700 dark:hover:bg-slate-900"
            >
              {{ action.label }}
            </NuxtLink>
          </div>
        </div>
      </div>
    </EnglishSection>

    <EnglishSection
      title="Quick Access"
      description="Zyada use hone wale pages yahan mil jayenge."
    >
      <EnglishGrid>
        <EnglishCard
          v-for="link in quickAccessLinks"
          :key="link.to"
          :title="link.title"
          description=""
          :to="link.to"
        />
      </EnglishGrid>
    </EnglishSection>

    <EnglishSection
      title="PDF Style Notes"
      description="Printable notes aur PDF page yahan se open karein."
    >
      <EnglishGrid>
        <EnglishCard title="Printable Notes" description="Clean structured notes aur easy revision layout." />
        <EnglishCard title="Notes PDF" description="Download PDF page open karein." to="/11th/computer/notes-pdf/" />
      </EnglishGrid>
    </EnglishSection>

    <EnglishSection
      title="Suggested Order"
      description="Agar chapter order follow karna ho to yahan se start karein."
    >
      <EnglishLinkList :links="learningPath.map((item) => ({ label: item.title, to: item.to }))" />
    </EnglishSection>
  </PageContainer>
</template>
